var map = {
	"./PROJMANAGE1.gif": 2391,
	"./PROJMANAGE2.gif": 8432,
	"./PROJMANAGE3.gif": 6489,
	"./PROJMANAGE4.gif": 7522,
	"./PROJMANAGE5.png": 5644
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5155;